module.exports = __webpack_public_path__ + "img/punta-del-este-4.8aa8eef4.jpg";